import React from 'react';
import { Formik, Form, Field } from 'formik';
import * as Yup from 'yup';
import IconArrow from '~/components/atoms/IconArrow';
import FadeInWhenVisible from '~/components/FadeInWhenVisible';
import useFormSubmit from '~/hooks/useFormSubmit';
import RadioField from '~/components/atoms/RadioField';
import { newsletterLabels } from '~/data/translations/newsletterLabels';

const validationSchema = Yup.object({
  email: Yup.string().email('Invalid email address').required('Required'),
  marketing_contact_type: Yup.string().required(),
});

export default function NewsletterSubscribe({ setIsSubmitted, pageLanguage, centered = false, theme = 'dark', formClassName }) {
  const { post, loading, response } = useFormSubmit({
    portalId: '7026924',
    formId: '54fe4638-962d-4508-bde8-3ce6d4f15a3f',
    setIsSubmitted,
  });

  const labels = newsletterLabels[pageLanguage ?? "en"];
  const isLight = theme === 'light';

  return (
    <FadeInWhenVisible className="w-full">
      <Formik
        initialValues={{
          email: '',
          marketing_contact_type: '',
        }}
        validationSchema={validationSchema}
        onSubmit={async (values) => {
          await post({
            // ...values,
            email: values.email,
            marketing_contact_type: values.marketing_contact_type,
            gdpr_check_box_text: 1,
          });
        }}
      >
        {(props) => (
          <Form className={`relative w-full group ${formClassName || (centered ? 'md:max-w-[369px] md:mx-auto' : '')}`}>
            <div className="relative group">
              <Field
                name="email"
                type="email"
                className={`bg-transparent border w-full outline-none transition-colors duration-200 ease-in-out rounded-[8px] newsletter-input ${isLight ? 'border-navy text-navy text-[14px] lg:text-[16px] placeholder:text-navy placeholder:text-opacity-50' : 'border-white border-opacity-30 group-hover:border-opacity-100 focus:border-opacity-100'}`}
                style={{ height: '60px', padding: '20px 25px 21px' }}
                placeholder={labels.inputPlaceholder}
              />
              <div className="cursor-pointer absolute top-0 bottom-0 right-4" onClick={() => props.handleSubmit()}>
                <button
                  type="submit"
                  className={`flex items-center justify-center w-12 h-full transition-opacity  hover:opacity-50 duration-200 ${!(props.isValid && props.dirty) && 'pointer-events-none'} `}
                >
                  <IconArrow className={`${isLight ? 'text-navy' : 'text-white'} transform -rotate-90`} />
                </button>
              </div>
            </div>
            <div className={`flex items-center mt-4 ${centered ? 'justify-center' : ''} ${isLight ? 'text-navy' : ''}`}>
              <div className="mr-4 text-sm font-bold md:text-base">{labels.inputLabel}</div>
              <div className="flex space-x-4" role="group">
                <RadioField
                  name="marketing_contact_type"
                  value="property_owner"
                  id="property-owner"
                  label={labels.propertyOwnerLabel}
                  inputClassName={isLight ? '!border-navy' : ''}
                  labelClassName={isLight ? 'lg:!text-base' : ''}
                />
                <RadioField
                  name="marketing_contact_type"
                  value="resident"
                  id="resident"
                  label={labels.residentLabel}
                  inputClassName={isLight ? '!border-navy' : ''}
                  labelClassName={isLight ? 'lg:!text-base' : ''}
                />
              </div>
            </div>
          </Form>
        )}
      </Formik>
    </FadeInWhenVisible>
  );
}
